export enum Requests {
  getPatientRegions = "getPatientRegions",
  getPatientRegionDetails = "getPatientRegionDetails",
  loadMorePatientRegions = "loadMorePatientRegions",
  getJoints = "getJoints",

  getPatient = "getPatient",
  assignTeamMembersToPatient = "assignTeamMembersToPatient",
  assignTeamLeadToPatient = "assignTeamLeadToPatient",
  getExam = "getExam",
  getExamGroup = "getExamGroup",
  getExamList = "getExamList",
  loadMoreExams = "loadMoreExams",
  getPatientDailyCheckinData = "getPatientDailyCheckinData",

  getExamFrames = "getExamFrames",
  getMinMaxFrames = "getMinMaxFrames",

  createNote = "createNote",
  editNote = "editNote",
  deleteNote = "deleteNote",

  getMe = "getMe",

  getClinicianList = "getClinicianList",
  getClinicianPatientStats = "getClinicianPatientStats",
  getClinicPatientsList = "getClinicPatientsList",
  getCurrentClinician = "getCurrentClinician",
  getSelectedClinician = "getSelectedClinician",
  updateCurrentClinician = "updateCurrentClinician",
  deleteClinician = "deleteClinician",
  deleteRecoveryTemplate = "deleteRecoveryTemplate",
  editClinicianCognitoGroups = "editClinicianCognitoGroups",
  createClinician = "createClinician",
  updateCurrentClinicianAvatar = "updateCurrentClinicianAvatar",
  loadMoreClinicians = "loadMoreClinicians",
  loadMoreClinicianPatients = "loadMoreClinicianPatients",
  loadMoreClinicPatients = "loadMoreClinicPatients",
  getClinicianPatients = "getClinicianPatients",
  getClinicianRecoveryTemplates = "getClinicianRecoveryTemplates",
  getClinicTeamLeads = "getClinicTeamLeads",
  getClinicTeamMembers = "getClinicTeamMembers",

  getClinicList = "getClinicList",
  loadMoreClinics = "loadMoreClinics",

  getClinicUserList = "getClinicUserList",
  loadMoreClinicUsers = "loadMoreClinicUsers",
}
